import Joi, { BasicType, Types } from 'joi';
import { Builder, Function } from '../types';

export class JoiSchemaBuilder implements Builder<Joi.AnySchema> {
	private schema: Joi.AnySchema = Joi['string']();
	type(type: Types): JoiSchemaBuilder {
		this.schema = Joi[type]();
		return this;
	}

	private _allowEmpty: boolean = true;
	allowEmpty(allowEmpty: boolean): JoiSchemaBuilder {
		this._allowEmpty = allowEmpty;
		return this;
	}

	private _valid?: unknown[];
	valid(valid: unknown[]): JoiSchemaBuilder {
		this._valid = valid;
		return this;
	}

	private defaultValue?: BasicType;
	default(defaultValue: BasicType): JoiSchemaBuilder {
		this.defaultValue = defaultValue;
		return this;
	}

	private _customOptionsAppliers: Function<Joi.AnySchema, Joi.AnySchema>[] = [];
	customOptionsAppliers(
		customOptionsAppliers: Function<Joi.AnySchema, Joi.AnySchema>[],
	): JoiSchemaBuilder {
		this._customOptionsAppliers = customOptionsAppliers;
		return this;
	}

	build(): Joi.AnySchema {
		if (this._allowEmpty) this.schema = this.schema.empty('');
		if (Array.isArray(this._valid))
			this.schema = this.schema.valid(...this._valid);
		if (this.defaultValue) this.schema = this.schema.default(this.defaultValue);
		this.schema = this._customOptionsAppliers.reduce(
			(prev, curr) => curr(prev),
			this.schema,
		);

		return this.schema;
	}
}
